module.exports = __webpack_public_path__ + "static/img/tow.d5059ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/smallFishImg/tow.png
// module id = 8iLA
// module chunks = 1